/**
 * Transformacje dla Text DSL
 * Dostępne transformacje: upper, lower, capitalize, quote, suffix:X, default:X
 */

/**
 * Kapitalizacja pierwszej litery
 */
function capitalize(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

/**
 * Zastosuj transformację do wartości
 * @param {string} value - wartość do transformacji
 * @param {string} transform - nazwa transformacji (może zawierać parametr po dwukropku)
 * @returns {string} - przetransformowana wartość
 */
export function applyTransform(value, transform) {
    if (!transform) return value;

    const [transformName, ...params] = transform.split(':');
    const param = params.join(':'); // na wypadek gdyby parametr zawierał dwukropek

    switch (transformName) {
        case 'upper':
            return String(value || '').toUpperCase();

        case 'lower':
            return String(value || '').toLowerCase();

        case 'capitalize':
            return capitalize(String(value || ''));

        case 'quote':
            // Dodaj polskie cudzysłowy
            return value ? `„${value}"` : '';

        case 'suffix':
            // Dodaj suffix jeśli wartość istnieje
            return value ? `${value} ${param}` : '';

        case 'prefix':
            // Dodaj prefix jeśli wartość istnieje
            return value ? `${param} ${value}` : '';

        case 'default':
            // Zwróć wartość domyślną jeśli puste
            return value || param || '';

        default:
            console.warn(`Nieznana transformacja: ${transformName}`);
            return value;
    }
}

/**
 * Zastosuj wiele transformacji do wartości
 * @param {string} value - wartość do transformacji
 * @param {string[]} transforms - tablica transformacji
 * @returns {string} - przetransformowana wartość
 */
export function applyTransforms(value, transforms) {
    return transforms.reduce((acc, transform) => applyTransform(acc, transform.trim()), value);
}

export default {
    applyTransform,
    applyTransforms
};
